import React from "react";
import { View } from "react-native";
import { createStackNavigator } from "@react-navigation/stack";
import { ZenText } from "zen-core-elements";

import AccountSettings from "../components/profile/accountSetting";
import MyAccount from "../components/profile/myAccount";
import ActivityLogs from "../components/profile/activityLog/activityLogs";

const ProfileStack = () => {
    const ProfileStack = createStackNavigator()
    return (
        <ProfileStack.Navigator
            initialRouteName={"AccountSettings"} screenOptions={{ headerShown: false, }}>
            <ProfileStack.Screen name="AccountSettings" component={AccountSettings} />
            <ProfileStack.Screen name="MyAccount" component={MyAccount} />
            <ProfileStack.Screen name="ActivityLogs" component={ActivityLogs} />
            <ProfileStack.Screen name="HelpCenter" children={() => (
                <View>
                    <ZenText content="Help center" />
                </View>
            )} />
        </ProfileStack.Navigator>
    )
}
export default ProfileStack